var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ramadan-balance"},[_c('span',[_vm._v(_vm._s(_vm.$t('ramadan.checkout.total')))]),_c('RamadanBadge',{attrs:{"count":String(_vm.tickets),"position":"start"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }